<!--
 * @Description: In User Settings Edit
 * @Author: your name
 * @Date: 2019-08-26 15:36:18
 * @LastEditTime: 2021-01-20 11:24:08
 * @LastEditors: daikeyi
 -->
<template>
    <div class="goods">
        <div class="goods-img">
            <img :src="good.productImages.split(',')[0]" alt="">
            <div class="dis" v-show="disShow">约赚¥{{good.maxStoreProfit ? good.maxStoreProfit.toFixed(2) : '0.00'}}</div>
        </div>
        <div class="goods-detail">
            <p class="goodstitle">{{good.name}}</p>
            <div class='goodIntegral'>
                <integralDeduction :goodData='good' v-if='good.maxDeductionAmount'></integralDeduction>
            </div>
            <p class="goodsprice" v-if='good.isMarketable === 2'>¥
                <span>{{good.minPrice.toString().split('.')[0]}}</span><span class="minMoney" v-if="good.minPrice.toString().split('.').length === 2">.{{good.minPrice.toString().split('.')[1]}}</span>
            </p>
            <van-row class='buydata' v-if='good.isMarketable === 2'>
                <van-col span="8" v-if="good.salesNum >= 10000 && good.salesNum <= 100000000">{{parseInt(good.salesNum/10000)+'万'}}人付款</van-col>
                <van-col span="8" v-if="good.salesNum >= 10000000">{{parseInt(good.salesNum/100000000)+'亿'}}人付款</van-col>
                <van-col span="8" v-if="good.salesNum <= 9999 && good.salesNum > 0">{{good.salesNum}}人付款</van-col>
                <van-col span="8" v-if="!good.salesNum || good.salesNum === 0">0人付款</van-col>
                <!-- <van-col span="8" v-if="good.contentNum >= 10000 && good.contentNum <= 100000000">{{parseInt(good.contentNum/10000)+'万'}}条评价</van-col>
                <van-col span="8" v-if="good.contentNum >= 10000000">{{parseInt(good.contentNum/100000000)+'亿'}}条评价</van-col>
                <van-col span="8" v-if="good.contentNum <= 9999 && good.contentNum > 0">{{good.contentNum}}条评价</van-col>
                <van-col span="8" v-if="!good.contentNum || good.contentNum === 0">0条评价</van-col> -->
                <van-col span="8">{{good.goodPoint ? good.goodPoint : 0}}%好评</van-col>
            </van-row>
            <p v-if='good.isMarketable === 1' class='sxP'>失效</p>
        </div>
    </div>
</template>
<script>
import integralDeduction from '@/components/common/integralDeduction';
export default {
    components: {
        integralDeduction
    },
    name: 'login',
    // props: ['good'],
    props: {
        good: {
            type: Object,
            required: true
        },
        disShow: {
            default: false
        }
    },
    data() {
        return {

        };
    },
    methods: {
        // 到商品详情
        godetail: function(item) {
            this.ESVStorage.putSavedValue('goodsId', item.productId);
            this.esvOpenPage({ name: 'OPGoodsdetail', params: { goodsId: item.productId } });
        }
    }
};
</script>
<style  lang="scss" scoped>
.goods{
    display: flex;
    align-items: center;
    clear: both;
    border-top: 0.5px solid #F6F6F6;
    border-bottom: 0.5px solid #F6F6F6;
    background-color: #FFF;
    padding: 12px;
    .goods-img{
        position: relative;
        width: 114px;
        height: 114px;
        img{
            width: 114px;
            height: 114px;
        }
        .dis {
            // width: 53px;
            height: 18px;
            top: 0;
            left: 0;
            background-color: #EE2E50;
            position: absolute;
            color: #FFF;
            text-align: center;
            font-size: 10px;
            line-height: 18px;
            padding: 0 6px;
        }
        margin-right: 12px;
    }

    .goods-detail{
        flex: 1;
        font-size:14px;
        .goodstitle{
            font-size: 14px;
            line-height: 20px;
            color: #414141;
            height: 40px;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }
        .goodsprice{
            color: #EE2E3A ;
            margin: 4px 0 6px;
            span{
                font-size: 20px;
            }
            .minMoney {
                font-size: 14px;
            }
        }
        .buydata{
            display: flex;
            // justify-content: space-between;
            color: #999;
            font-size: 12px;
        }
        .sxP {
            margin-top: 30px;
            background: #bebec5;
            border-radius: 2px;
            width: 36px;
            color: white;
            text-align: center;
        }
    }
}
@media screen and (min-width:320px) and (max-width:359px){
    .goods{
        .goods-img{
        img{
            width: 100px;
            height: 100px;
            }
            margin:12px 6px 12px 6px;
        }
        .goods-detail{
            float:left;
            width: 195px;
            .buydata{
                span{
                    padding-right: 0px;
                }
            }
        }
    }
}
.goodIntegral{
    height:22px;
}
</style>
